import trackFactory from './track/factory';
import Type from './track/Type';
function isITracks(init) {
    return typeof init[Symbol.iterator] === 'function';
}
export class Tracks {
    constructor(init) {
        const {tracks} = isITracks(init) ? { tracks: init } : init;
        this.tracks = Array.from(tracks, trackFactory);
        const descriptors = Object.getOwnPropertyDescriptors(this);
        descriptors.tracks.configurable = false;
        descriptors.tracks.enumerable = false;
        descriptors.tracks.writable = false;
        Object.defineProperties(this, descriptors);
    }
    get vocabulary() {
        return this.tracks.find(({type}) => type === Type.Vocabulary);
    }
    get transcript() {
        return this.tracks.find(({type}) => type === Type.Transcript);
    }
}
export default Tracks;    //# sourceMappingURL=Tracks.js.map
